// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__110w-solar-panel_productcontent__bY65T"};